import * as Yup from 'yup';

export const validateSn = (checkSn: any) =>
  Yup.number()
    .required('This field is required')
    .test({
      name: 'test-serial-length',
      message: 'Serial number requires 6 to 7 digits',
      test: (value) => {
        return !(
          !value ||
          (value.toString().length !== 7 && value.toString().length !== 6)
        );
      },
    })
    .test({
      name: 'test-wrong-serial',
      message:
        'Please insert the serial number of the Measuring Cell (40xxxxx or 50xxxxx)',
      test: (value) => {
        if (!value || value.toString().length !== 7) return true;

        const sn = value.toString();
        return (
          !sn.startsWith('1') && !sn.startsWith('2') && !sn.startsWith('3')
        );
      },
    })
    .test({
      name: 'test-serial-exists',
      message: 'Unknown serial number',
      test: async function (value) {
        return checkSn(value, this);
      },
    });
